import type { CatalogsResponse } from "@/services/catalogService";
import { useCallback, useEffect, useMemo, useState } from "react";

const defaultFields = [
    {
        label: "ID de SKU *",
        id: "sku_number",
        type: "text",
        placeholder: "Digita el ID del SKU",
        readOnly: true,
    },
    {
        label: "Nombre *",
        id: "name",
        type: "text",
        placeholder: "Digita el nombre del SKU",
        readOnly: false,
    },
    {
        label: "Marca *",
        id: "brand",
        type: "dropdown",
        placeholder: "Selecciona la marca",
        options: [],
    },
    {
        label: "Presentación *",
        id: "presentation",
        type: "dropdown",
        placeholder: "Selecciona la presentación",
        options: [],
    },
    {
        label: "Volumen *",
        id: "volume",
        type: "dropdown",
        placeholder: "Selecciona el volumen",
        options: [],
    },
    {
        label: "Cantidad *",
        id: "quantity",
        type: "dropdown",
        placeholder: "Selecciona la cantidad",
        options: [],
    },
    {
        label: "Tipología de producto *",
        id: "tipology",
        type: "dropdown",
        placeholder: "Selecciona la tipología",
        options: [],
    },
    {
        label: "Tamaño *",
        id: "size",
        type: "dropdown",
        placeholder: "Selecciona el tamaño",
        options: [],
    },
]

interface UseSkuFormFieldsProps {
    catalogs?: CatalogsResponse | null;
}

export const useSkuFormFields = (props?: UseSkuFormFieldsProps | undefined) => {
    const [localCatalogs, setLocalCatalogs] = useState<CatalogsResponse | null>(null);

    const brands = useMemo(() => localCatalogs?.brands.map((brand) => ({ value: brand.name, label: brand.name })) || [], [localCatalogs?.brands]);
    const presentations = useMemo(() => localCatalogs?.presentations.map((presentation) => ({ value: presentation.name, label: presentation.name })) || [], [localCatalogs?.presentations]);
    const volumes = useMemo(() => localCatalogs?.volumes.map((volume) => ({ value: volume.name, label: volume.name })) || [], [localCatalogs?.volumes]);
    const quantities = useMemo(() => localCatalogs?.quantities.map((quantity) => ({ value: quantity.name, label: quantity.name })) || [], [localCatalogs?.quantities]);
    const typologies = useMemo(() => localCatalogs?.typologies.map((typology) => ({ value: typology.name, label: typology.name })) || [], [localCatalogs?.typologies]);
    const sizes = useMemo(() => localCatalogs?.sizes.map((size) => ({ value: size.id, label: size.id })) || [], [localCatalogs?.sizes]);

    const fields = useMemo(() => {
        return defaultFields.map((field) => {
            if (field.type === "dropdown") {
                switch (field.id) {
                    case "brand":
                        return { ...field, options: brands };
                    case "presentation":
                        return { ...field, options: presentations };
                    case "volume":
                        return { ...field, options: volumes };
                    case "quantity":
                        return { ...field, options: quantities };
                    case "tipology":
                        return { ...field, options: typologies };
                    case "size":
                        return { ...field, options: sizes };
                    default:
                        return field;
                }
            }
            return field;
        });
    }, [brands, presentations, volumes, quantities, typologies]);

    const setCatalogs = useCallback((catalogs: CatalogsResponse) => {
        setLocalCatalogs(catalogs);
    }, []);

    useEffect(() => {
        setLocalCatalogs(props?.catalogs || null);
    }, [props?.catalogs]);

    return {
        fields,
        setCatalogs,
    };
};